import React, { useEffect, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import messages from './messages';
import { completeEmailVerification } from '../api/store-api';
import { SettingsPageTitle } from '../components/settings-page-title/settings-page-title';
import style from '../settings-page.module.less';

export const EmailVerificationPage = () => {
  const params = new URL(document.location).searchParams;
  const token = params.get('token');
  const [email, setEmail] = useAsyncSafeState();
  const [isLoading, setIsLoading] = useAsyncSafeState(false);
  const [hasError, setHasError] = useAsyncSafeState(!token);
  const verifyEmail = useCallback(async () => {
    setIsLoading(true);
    completeEmailVerification(token).then(
      (response) => {
        setIsLoading(false);
        setEmail(response?.data);
      },
      () => {
        setIsLoading(false);
        setHasError(true);
      },
    );
  }, [token, setHasError, setIsLoading, setEmail]);

  useEffect(() => {
    if (token) {
      verifyEmail();
    }
  }, [token, verifyEmail]);

  if (isLoading) {
    return (
      <div className={style.content}>
        <SettingsPageTitle value={messages.verifying} />
      </div>
    );
  }

  if (hasError) {
    return (
      <div className={style.content}>
        <SettingsPageTitle value={messages.error} />
      </div>
    );
  }

  return (
    <div className={style.content}>
      <SettingsPageTitle value={messages.verified} />
      <h3>
        <FormattedMessage {...messages.confirmation} />
      </h3>
      <h3>
        <FormattedMessage {...messages.sendEmails} values={{ email }} />
      </h3>
    </div>
  );
};
